import React from "react";
import "./App.css";
import Game from "./components/Game";

function App() {
  return (
    <div className='App'>
      <main>
        <Game />
      </main>
    </div>
  );
}

export default App;
